<template>
    <div class="flex flex-col mx-auto w-11/12">
        <router-link
            :to="{ name: 'serie', params: { id: serie.id } }"
            :alt="serie.title"
        >
            <app-image
                :url="serie.more.preview"
                class="w-full mb-2 rounded-lg"
                :alt="serie.title"
                lazy
            >
            </app-image>
        </router-link>

        <p class="font-primary text-xl text-white leading-tight">
            {{ serie.title }}
        </p>
    </div>
</template>

<script>
export default {
    name: "serie",

    props: {
        serie: {
            type: Object,
            required: true
        }
    }
};
</script>
